import NetworkLogic from "../Shared/NetworkLogic";
import Constant from "../Shared/Constant";
import UIManager from "../Shared/UIManager";
import { Global } from "../Shared/Global";
import Player from "../Models/Player";
import SDKManager from "../Shared/SDKManager";
import AudioManager from "../Shared/AudioManager";
import AddressManager from "../Shared/AddressManager";
import EnterSoundManager from "../Shared/EnterSoundManager";
import ToggleItem from "../Common/ToggleItem";
import RemoteSprite from "../Common/RemoteSprite";
import Utils from "../Shared/Utils";
const i18n = require('LanguageData');

const { ccclass, property } = cc._decorator;

@ccclass
export default class RegisterUI extends cc.Component {
    @property(cc.Prefab)
    pfbLoginUI: cc.Prefab = null
    @property(cc.Prefab)
    pfbLoginItem: cc.Node = null
    @property(cc.Node)
    nodeItems: cc.Node = null
    @property(cc.Node)
    nodeContent: cc.Node = null
    @property(cc.Node)
    nodeUserName: cc.Node = null
    @property(cc.Node)
    phoneLoginItem : cc.Node = null;//手机号节点
    @property(cc.Button)
    btnSend : cc.Button = null;//手机号节点

    @property(cc.Label)
    lbAreaCode : cc.Label = null;//区号label
    @property(cc.EditBox)
    ebPhoneNum : cc.EditBox  = null;//手机号edBox
    @property(cc.Node)
    nodePhoneCode: cc.Node = null//手机验证码节点
    @property(cc.EditBox)
    ebPhoneCode: cc.EditBox = null//手机验证码输入
    @property(cc.Node)
    nodeCode: cc.Node = null//图形验证码节点
    @property(cc.EditBox)
    ebUserName: cc.EditBox = null
    @property(cc.EditBox)
    ebPossword: cc.EditBox = null
    @property(cc.EditBox)
    ebConfirm: cc.EditBox = null
    @property(cc.EditBox)
    ebCode: cc.EditBox = null//图形码输入
    @property(cc.Sprite)
    spCode: cc.Sprite = null//图形码图片，从后台获取
    @property(cc.Label)
    lbCodeTime: cc.Label = null;//发送时间

    @property(cc.Node)
    AreaCodeLayer: cc.Node = null;
    @property(cc.Node)
    toggleItem: cc.Node = null;
    @property(cc.Node)
    areaContent : cc.Node = null;

    @property(cc.Label)
    currencyLabel: cc.Label = null;
    @property(cc.Label)
    languageLabel: cc.Label = null;
    @property(RemoteSprite)
    languageIcon: RemoteSprite = null;
    @property(cc.Node)
    langToggleItem: cc.Node = null;
    @property(cc.Node)
    langToggleContent: cc.Node = null;
    @property(cc.Node)
    currencyToggleItem: cc.Node = null;
    @property(cc.Node)
    currencyToggleContent: cc.Node = null;
    @property(cc.Node)
    nodeLangScroll: cc.Node = null;
    @property(cc.Node)
    nodeCurrencyScroll: cc.Node = null;
    @property(cc.Node)
    nodePosCur: cc.Node = null;
    @property(cc.Node)
    nodeTips: cc.Node = null;
    @property(cc.Node)
    currencyTips: cc.Node = null;
    currencyLanguageDto = null;

    private _codeId: number = 0;
    private _codeCD: number = 0;
    private _userLoginConfig = null
    private _channelCode: string = ""
    private _bindData: {} = null

    private areaLanguageData  = null;
    private selectAreaCodeData = null;
    private _languageData = null;

    private confirmAgentCurrency = false;
    agentCodeEb : cc.EditBox  = null

    async start() {
        cc.sys.localStorage.setItem("OpenRegister", "");
        this.nodeItems.active = false
        this._channelCode = Global.installParms[0];
        this._bindData = Global.installParms[1];
        await this.getLanguageData();
        await this.downloadUserConfig();
        if(!this._userLoginConfig)return ;
        let registerTypeCfg = this._userLoginConfig["userLoginConfig"] || []
        for (let i = 0 ;i < registerTypeCfg.length;i++){//获取区号
            let cfg = registerTypeCfg[i];
            if  (cfg["registerFieldName"] === "phone"){
                await this.areaLanguageFlag();
                break;
            }
        }

        //if (this._userLoginConfig.)
        this.showItemsFromLoginConfig()

        this.refreshCodeImage()
        EnterSoundManager.playSound("enter_zhuce")
    }

    update(dt) {
        if (this._codeCD > 0) {
            this._codeCD -= dt

            if (this._codeCD <= 0) {
                this._codeCD = 0;
                this.btnSend.interactable = true;
                this.lbCodeTime.string = i18n.t('register_text.send_verify')
            } else {
                this.lbCodeTime.string = i18n.t('register_text.retry_verify') + "(" + Math.ceil(this._codeCD).toString() + ")"
            }
        }
    }

    onBtnClick(event, userData) {
        if (userData === "register") {
            this.register()
        } else if (userData === "send") {//发送短信验证码
            if (this._codeCD > 0) {
                return
            }
            this.btnSend.interactable = false;
            let phoneNum =  this.ebPhoneNum.string ;
            if (phoneNum.length < 6 || phoneNum.length > 15 || !(/^\d+$/.test(phoneNum))) {
                UIManager.showToastUI(i18n.t('register_text.phone_confirm'), Global.ToastType.Warnning)
            } else {
                UIManager.showLoadingUI();
                let call = null
                let d: any = { phone: phoneNum };
                if (this._userLoginConfig.aliOrVonage == 0) {// 0 阿里短信接口，1 vonage 短信接口
                    d.area = this.selectAreaCodeData.areaNumber
                    call = NetworkLogic.phoneCode.bind(NetworkLogic)
                }
                else {
                    d.area = this.selectAreaCodeData.areaNumber
                    call = NetworkLogic.vonageSms.bind(NetworkLogic)
                }
                call(d, (data) => {
                    UIManager.hideLoadingUI();
                    UIManager.showToastUI(i18n.t("sendSuccess"),Global.ToastType.OK)
                    this._codeCD = 60;
                },()=>{
                    cc.log("===短信发送失败");
                    this.btnSend.interactable = true;
                })
                //NetworkLogic.phoneCode(phoneNum)
            }
        } else if (userData === "go") {
            cc.instantiate(this.pfbLoginUI).parent = this.node.parent
            this.node.destroy()
        } else if (userData === "code") {
            this.refreshCodeImage()
        } else if (userData === "close") {
            AudioManager.playSound("close")
            cc.sys.localStorage.setItem("OpenRegister","");
            this.node.destroy()
        }
    }

    private register() {
        if (!this.check()) {
            return
        }
        cc.log("===手机验证码：",this.ebPhoneCode.string);

        let agentCode = this._bindData && this._bindData["code"];
        if  (!agentCode  && this.agentCodeEb){
            agentCode =  this.agentCodeEb.string;
        }

        let data = {
            "agentUrl": "",
            "channelDomain": "",
            "channelFlag": "",
            "code": this.ebCode.string,
            "codeId": this._codeId === 0 ? "" : this._codeId.toString(),
            "deviceFlag": "",
            "deviceModel": cc.sys.isMobile ? jsb.device.getDeviceModel() : "",
            "deviceType": cc.sys.os === cc.sys.OS_ANDROID ? "1" : "2",
            "domainId": this._channelCode,
            "email": cc.find("email/EditBox", this.nodeContent) ? cc.find("email/EditBox", this.nodeContent).getComponent(cc.EditBox).string : "",
            "ipAdr": "",
            "parentAgentCode": agentCode,
            "phone": this.ebPhoneNum.string || "",
            "phoneCode": this.ebPhoneCode.string,
            "pwd": this.ebPossword.string,
            "qq": cc.find("qq/EditBox", this.nodeContent) ? cc.find("qq/EditBox", this.nodeContent).getComponent(cc.EditBox).string : "",
            "area" : this.selectAreaCodeData && this.selectAreaCodeData.areaNumber,
            "sign": "",
            "uaToken": "",
            "userId": this.ebUserName.string,
            "verifyPwd": this.ebConfirm.string,
            "weChat": cc.find("wechat/EditBox", this.nodeContent) ? cc.find("wechat/EditBox", this.nodeContent).getComponent(cc.EditBox).string : "",
            "webUmidToken": "",
            "currencyType" : this.currencyLanguageDto.currencyType,
            "confirmAgentCurrency" : this.confirmAgentCurrency
        }
        UIManager.showLoadingUI();
        NetworkLogic.register(data, function (data) {
            UIManager.hideLoadingUI();
            UIManager.showToastUI(i18n.t('register_text.register_suc'), Global.ToastType.OK)
            if (Constant.InstallSDK === 0) {
                SDKManager.reportRegister()
            }else if (Constant.InstallSDK === 1) {
                SDKManager.shareInstallReportRegister()
            }
            cc.director.emit(Global.UserEvent.AfterLogin);
            Player.setPy("token", data.token);

            this.node.destroy()
        }.bind(this), function (response) {
            UIManager.hideLoadingUI();
            cc.log("==response",response)
            if (!response) return;
            this.refreshCodeImage();
            if (response.code === "20064"){
                let str  = response.msg;
                UIManager.showConfirmUI(str,function () {
                    this.confirmAgentCurrency = true;
                    this.register();
                }.bind(this))
            }


        }.bind(this))
    }

    private refreshCodeImage() {
        this._codeId = Math.floor(Math.random() * 1000)
        let remoteUrl = AddressManager.getServerAdress() + "/api/user/generator-code?code_id=" + this._codeId.toString();
        cc.loader.load({ url: remoteUrl, type: 'png' }, function (err, texture: cc.Texture2D) {
            if (!err && this.node) {
                var spriteFrame = new cc.SpriteFrame(texture)
                this.spCode.spriteFrame = null
                this.spCode.spriteFrame = spriteFrame
            }
        }.bind(this));
    }

    private downloadUserConfig():Promise<any> {
        return new Promise<any>((reslove)=>{
            UIManager.showLoadingUI()
            NetworkLogic.userLoginConfig({
                agentCode: this._bindData["code"] || "",
            },function (data) {
                UIManager.hideLoadingUI()
                this._userLoginConfig = data;
                // if  (CC_DEBUG){
                //     data = {
                //         currencyLanguageDto:[{
                //             currencyDefault: "",
                //             currencyName: "韩圆",
                //             currencyRate: "",
                //             currencySymbol: "₩",
                //             currencyTitle: "韩圆",
                //             currencyType: "KRW"
                //         }]
                //     }
                // }
                if (!Array.isArray(data.currencyLanguageDto) || data.currencyLanguageDto.length<=0) return;
                this.currencyLabel.node.parent.active = (data.currencyLanguageDto.length > 1)
                if  (data.currencyLanguageDto.length === 1){
                    this.onBtnCurrencySelected(null,data.currencyLanguageDto[0]);
                    let btn = this.currencyLabel.node.parent.getChildByName("btnChooseCode").getComponent(cc.Button)
                    btn.interactable = false;
                    btn.node.getChildByName("spXiala").active = false;

                }else{
                    this.createCurrencyList(data.currencyLanguageDto);
                }
                reslove();
            }.bind(this),function (){
                reslove();
            })
        })
    }

    createCurrencyList(currencyList){
        for (let i = 0;i < currencyList.length;i++){
            let item = cc.instantiate(this.currencyToggleItem);
            item.parent = this.currencyToggleContent;
            item.getChildByName("lbBack").getComponent(cc.Label).string = currencyList[i].currencyName ;
            item.getComponent(cc.Button).clickEvents[0].customEventData = currencyList[i];
            item.active = true;
        }
        //this.currencyLabel.string = this.currencyLanguageDto.currencyName;
    }


    //请求区号接口（当注册手机条件打开时）
    areaLanguageFlag() {
        UIManager.showLoadingUI()
        return new Promise((resolve, reject) => {
            NetworkLogic.areaLanguageFlag((d) => {
                this.areaLanguageData = d;
                this.setAreaCode(d)
                UIManager.hideLoadingUI()
                resolve()
            }, async (e) => {
                cc.log("===区号接口获取失败");
                //await this.areaLanguageFlag()
            })
        })
    }


    //设置国家区号
    setAreaCode(rec) {
        if(!rec) return;
        let lan = cc.sys.localStorage.getItem("CurrentLanguage");
        cc.log("--=lan:",lan);
        let dataArr = rec.filter((item)=>{
            if (item.languageFlag === lan){
                return true;
            }
        })
        cc.log("====dataArr",JSON.stringify(dataArr))
        if  (dataArr.length <= 0){
            dataArr[0] = rec[0];
        }
        this.lbAreaCode.string = dataArr[0].languageTranslation +  dataArr[0].areaNumber
        this.selectAreaCodeData = dataArr[0];

    }

    private showItemsFromLoginConfig() {
        this.nodeItems.active = true
        this.nodePhoneCode.active = false
        this.nodeCode.active = false

        // 注册图形验证码
        if (parseInt(this._userLoginConfig["isOpenReCode"]) === 0) {//0 开启，1 关闭
            this.nodeCode.parent = null
            this.nodeCode.parent = this.nodeContent
            this.nodeCode.active = true
        }

        let registerTypeCfg = this._userLoginConfig["userLoginConfig"] || []

        for (let i = 0; i < registerTypeCfg.length; i++) {
            const cfg = registerTypeCfg[i];
            let loginItem = null
            if  (cfg["registerFieldName"] === "phone"){
                this.phoneLoginItem.parent = this.nodeContent;
                this.phoneLoginItem.active = true;
                loginItem = this.phoneLoginItem.getChildByName("LoginItem");
                //区号
                let nodeAreaCode = this.phoneLoginItem.getChildByName("areaCode")

            }else{
                loginItem = cc.instantiate(this.pfbLoginItem)
                loginItem.parent = this.nodeContent;
            }
            let editBox = loginItem.getChildByName("EditBox").getComponent(cc.EditBox)

            loginItem.name = cfg["registerFieldName"]
            loginItem.getComponent(cc.Label).string = cfg["registerName"] + "："
            editBox.placeholder = i18n.t('label_text.inPlease_enter_the') + cfg["registerName"] //+ i18n.t('label_text.No')

            if (cfg["registerFieldName"] === "phone") {
                editBox.inputMode = cc.EditBox.InputMode.PHONE_NUMBER
                editBox.maxLength = 15
            } else if (cfg["registerFieldName"] === "qq") {
                editBox.inputMode = cc.EditBox.InputMode.NUMERIC
            }
            else if (cfg["registerFieldName"] === "agentCode" ){
                loginItem.getComponent(cc.Label).string = i18n.t("agentCode") + "：";
                let str = i18n.t('label_text.inPlease_enter_the') + i18n.t("agentCode");
                if  (!cfg["isNotNull"]){
                    str += `(${i18n.t('optional')})`
                }
                editBox.placeholder = str;
                editBox.maxLength = 15
                this.agentCodeEb = editBox;
                if  (this._bindData && this._bindData["code"])  {
                    editBox.string = this._bindData["code"];
                    editBox.enabled = false;
                }
            }

        }

        // 注册手机验证码
        if (parseInt(this._userLoginConfig["isOpenPhoneCode"]) === 0) {//是否开启手机验证码
            this.nodePhoneCode.parent = null
            this.nodePhoneCode.parent = this.nodeContent;
            this.nodePhoneCode.active = true
        }
    }

    /*
    areaNumber: "+86"
    ccurrencyType: "CNY"
    defaultCcurrency: 1
    id: 1
    languageFlag: "zh_CN"
    languageFlagGroup: "zh_CN"
    languageTranslation: "中国(大陆)"
     */
    //点击获取区号
    onBthAreaCode(){
        if (!this.areaLanguageData) return;
        this.AreaCodeLayer.active = true;
        for (let i = 0;i < this.areaLanguageData.length;i++){
            let data = this.areaLanguageData[i]
            let item = null;
            if (this.areaContent.children.length > i){
                item = this.areaContent.children[i];
            }else{
                item = cc.instantiate(this.toggleItem);
            }

            item.getChildByName("labAreaCode").getComponent(cc.Label).string = data.languageTranslation + " " + data.areaNumber;
            let tog = item.getComponent(cc.Toggle)
            tog.checkEvents[0].customEventData = data;
            item.parent = this.areaContent;
            item.active = true;
            if (data.areaNumber === this.selectAreaCodeData.areaNumber){
                tog.check();
            }
        }
    }

    onToggleSelected(event,param){
        this.lbAreaCode.string = param.languageTranslation +  param.areaNumber;
        this.selectAreaCodeData = param
    }

    onBtnAreaLayerClose(){
        this.AreaCodeLayer.active = false;
    }

    private check(): boolean {
        if  (!this.currencyLanguageDto){
            UIManager.showToastUI(i18n.t('register_chooseCurrency'), Global.ToastType.Warnning)
            return false;
        }
        if (this.ebUserName.string.length === 0) {
            UIManager.showToastUI(i18n.t('register_text.user_not_mag'), Global.ToastType.Warnning)
            return false
        } else if (this.ebUserName.string.length < 6 || this.ebUserName.string.length > 12 || !(/\d+/.test(this.ebUserName.string) && /[a-zA-Z]+/.test(this.ebUserName.string)) ) {
            UIManager.showToastUI(i18n.t('register_text.user_pro'), Global.ToastType.Warnning)
            return false
        }
        if (/\s/.test(this.ebUserName.string)){
            UIManager.showToastUI(i18n.t('register_text.user_pro'), Global.ToastType.Warnning)
            return false

        }
        if (/\s/.test(this.ebPossword.string)){
            UIManager.showToastUI(i18n.t('register_text.paw_pro'), Global.ToastType.Warnning)
            return false
        }
        let pwdRegex = /[^0-9A-Za-z~！\\\\@#￥%&()*-_=+{}[]|;:''"",.<>?]+/g;
        if (pwdRegex.test(this.ebPossword.string)){
            UIManager.showToastUI(i18n.t('register_text.paw_pro'), Global.ToastType.Warnning)
            cc.log("===不行");
            return false
        }

        if (this.ebPossword.string.length === 0) {
            UIManager.showToastUI(i18n.t('login_text.psw_pro'), Global.ToastType.Warnning)
            return false
        } else if (this.ebPossword.string.length < 6 || this.ebPossword.string.length > 12 ) {
            UIManager.showToastUI(i18n.t('register_text.paw_pro'), Global.ToastType.Warnning)
            return false
        }

        if (this.ebConfirm.string.length === 0) {

            UIManager.showToastUI(i18n.t('register_text.confirm_paw_pro'), Global.ToastType.Warnning)
            return false
        } else if (this.ebConfirm.string !== this.ebPossword.string) {
            UIManager.showToastUI(i18n.t('register_text.paw_consistent'), Global.ToastType.Warnning)
            return false
        }

        // 注册图形验证码
        if (parseInt(this._userLoginConfig["isOpenReCode"]) === 0) {
            if (this.ebCode.string.length === 0) {
                UIManager.showToastUI(i18n.t('register_text.paw_pro'), Global.ToastType.Warnning)
                return false
            }
        }

        let registerTypeCfg = this._userLoginConfig["userLoginConfig"] || []

        for (let i = 0; i < registerTypeCfg.length; i++) {
            const cfg = registerTypeCfg[i];
            let editBox = null;
            if (cfg["registerFieldName"] === "phone"){
                editBox = this.ebPhoneNum;
            }else{
                editBox = cc.find(cfg["registerFieldName"] + "/EditBox", this.nodeContent).getComponent(cc.EditBox)
            }
            if (cfg["isNotNull"]) {
                if (editBox.string.length === 0) {
                    i18n.t('register_text.No_null')
                    UIManager.showToastUI(cfg["registerName"] + i18n.t('register_text.No_null'), Global.ToastType.Warnning)
                    return false
                } else if (cfg["registerFieldName"] === "phone" && (editBox.string.length < 6 || editBox.string.length > 15 || !(/^\d+$/.test(editBox.string)))) {
                    UIManager.showToastUI(i18n.t('register_text.correct_phone'), Global.ToastType.Warnning)
                    return false
                }
            }
        }

        // 手机验证码
        if (parseInt(this._userLoginConfig["isOpenPhoneCode"]) === 0) {
            if (this.ebPhoneCode.string.length === 0) {
                UIManager.showToastUI(i18n.t('register_text.phone_vfy'), Global.ToastType.Warnning)
                return false
            }
        }

        return true
    }

    private initLanguageToggles() {
        if (!Array.isArray(this._languageData) || this._languageData.length <= 0) return;
        this.languageLabel.node.parent.active = (this._languageData.length > 1)
        if (this._languageData.length === 1) {
            this.onLangToggleSelected(null, this._languageData[0]);
            let btn = this.languageLabel.node.parent.getChildByName("btn").getComponent(cc.Button)
            btn.interactable = false;
            btn.node.getChildByName("xiala").active = false;
            let data = this._languageData[0];
            this.languageLabel.string = data.languageName;
            this.languageIcon.url = data.languageUrl;
        } else {
            let language = cc.sys.localStorage.getItem("CurrentLanguage")
            for (let j = 0; j < this._languageData.length; j++) {
                const data = this._languageData[j];
                if (data.status !== 1) {
                    continue
                }
                let togItem = cc.instantiate(this.langToggleItem);
                togItem.parent = this.langToggleContent;
                cc.find("lbBack", togItem).getComponent(cc.Label).string = data.languageName;
                //cc.find("checkmark/lbCheck",togItem).getComponent(cc.Label).string = data.languageName;
                togItem.getChildByName("icon").getComponent(RemoteSprite).url = data.languageUrl;
                togItem.active = true;
                let tog = togItem.getComponent(cc.Button)
                tog.clickEvents[0].customEventData = data;
                if (language === data.languageFlag) {
                    this.languageLabel.string = data.languageName;
                    this.languageIcon.url = data.languageUrl;

                    this.onLangToggleSelected(null, data);
                }
            }
        }
    }

    onLangToggleSelected(event,param){
        cc.log("===进入 语言Toggle param：",param);
        let language = cc.sys.localStorage.getItem("CurrentLanguage")
        if  (language === param.languageFlag){
            this.nodeLangScroll.active = false;
            return
        }
        this.languageLabel.string = param.languageName;
        this.languageIcon.url = param.languageUrl;
        this.nodeLangScroll.active = false;
        SDKManager.setTags([param.languageFlag])
        i18n.init(param.languageFlag)
        cc.sys.localStorage.setItem("CurrentLanguage", param.languageFlag);
        cc.sys.localStorage.setItem("OpenRegister", "register");

        UIManager.showTipUI(i18n.t("set_text.change_language_tips"), function () {
            Utils.restartGame()
        }.bind(this), i18n.t("set_text.restart"))

    }

    onCloseLang(){
        this.nodeLangScroll.active = false;

    }

    onBtnCurrencySelected(event,param){
        this.currencyTips.active = false;
        this.currencyLanguageDto = param;
        this.currencyLabel.string = param.currencyName;
        this.nodeCurrencyScroll.active = false;

    }

    onBtnChooseLanguage(){
        this.nodeLangScroll.active = !this.nodeLangScroll.active;
    }

    onBtnChooseCurrency(){
        //this.nodeCurrencyScroll.position = Utils.local_world__POS(this.nodePosCur);
        this.nodeCurrencyScroll.active = !this.nodeCurrencyScroll.active;
    }

    onBtnCloseTips(){
        this.nodeTips.active = false;
    }

    onBtnTips(){
        this.nodeTips.active = true;
    }

    private getLanguageData () : Promise<any> {
        return new Promise<any>(resolve => {
            UIManager.showLoadingUI()
            NetworkLogic.getLanguageListAll(function (data) {
                UIManager.hideLoadingUI();
                this._languageData = data;
                this.initLanguageToggles();
                resolve(data)
            }.bind(this), function (response) {
                UIManager.hideLoadingUI();
                resolve([])
            }.bind(this))
        })
    }
}
